import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DeviceDataValidationService {

    constructor(private readonly http: HttpClient) { }

    getValidationCategories(serial: string): Observable<ValidationCheckType[]> {
        return this.http.get<ValidationCheckType[]>(`/api/foundation/devicevalidation/${serial}`);
    }

    getValidationResults(validationRequestParameters: ValidationRequestParameters): Observable<ValidationCheck> {
        return this.http.get<ValidationCheck>(`/api/foundation/devicevalidation/run/`, { params: validationRequestParameters as HttpParams });
    }
}

export interface ValidationRequestParameters {
    Serial?: string,
    CheckType?: ValidationCheckType,
    StartTime?: string,
    EndTime?: string,
    ParentTrackerImei?: string,
    IncludeTemperatureModule?: boolean,
    IncludePtoTest?: boolean
}

export interface ValidationCheck {
    ValidationCheckType?: ValidationCheckType
    ValidationResults?: ValidationTestResult[],
    TestData?: any[],
    ValidationResultDatabaseId?: number
}

export interface ValidationTestResult {
    Status: ValidationStatus,
    TestResponseString: string,
    InfoMessageString: string
}

export enum ValidationStatus {
    NotRun,
    Pass,
    Fail,
    Warning,
    Info
}

export enum ValidationCheckType {
    Plot,
    SensorData,
    Core,
    Temperature,
    AddsecureCamera,
    FtCloud,
    DigiDl,
    Sim,
    Ceiba
}
